module.exports = __webpack_public_path__ + "img/radio.3d528dc5.png";